// Polished trademark mark for "The Operator Walk". Renders a tasteful superscript
// TM (about half the surrounding text height) that does not affect line height.
// Place immediately after the name with no space: The Operator Walk<Tm />
export default function Tm() {
  return (
    <sup className="tm" aria-label="trademark">
      TM
    </sup>
  );
}
